import React from 'react';
import PropTypes from 'prop-types';
import { Cell } from 'fixed-data-table-2';
import cn from 'classname';

import find from 'lodash/find';
import forEach from 'lodash/forEach';

const propTypes = {
	filterKey: PropTypes.string,
	data: PropTypes.array,
	type: PropTypes.string,
	rowIndex: PropTypes.number,
	cellConfig: PropTypes.array,
	axesCalculateData: PropTypes.object,
	classNameModify: PropTypes.string
};

class Data extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { data, column } = this.props.data[this.props.rowIndex];
		const entity = find(data, {date: this.props.filterKey});
		const isCellTotal = column.is_total;

		return (
			<Cell>
				<div className={cn(
					`activity-table-wrapper__cell activity-table-wrapper__cell--data`,
					this.props.classNameModify && `activity-table-wrapper__cell--${this.props.classNameModify}`,
					isCellTotal && 'activity-table-wrapper__cell--total'
				)}>
					<div className="data">
						{this.renderCell(entity, this.props.rowIndex)}
					</div>
				</div>
			</Cell>
		);
	}

	renderCell(entity, rowIndex)  {
		const res = [];
		entity.activeCell.map((entityName, index) => {
			const coefData = entity.coefData[entityName] || {};
			const coefStyleHeight = coefData.coef ? coefData.coef < 10 ? 10 : coefData.coef : 0;
			res.push(
				<div
					className="data-item"
					data-row={rowIndex}
					data-row-type={entityName}
					key={index}
					onMouseOver={this.onHandleMouseOver.bind(this)}
					onMouseLeave={this.onHandleMouseLeave.bind(this)}>
					<span
						className={
							cn(
								`js-item-by-row-index-${entityName}-${rowIndex}`,
								'data-item__highlight',
								coefData.isMaxValueInGroup && 'data-item__highlight--max-value'
							)
						}
						style={{height: `${coefStyleHeight}%`}}/>
					<span
						key={entityName}
						className={cn({
							'data-item__value': true,
							[entityName]: true,
							[entity.difference]: entityName === 'total' && entity.difference
						})}>
						{
							entityName === 'accepted'
								? (
									<span>
										<span className="accepted-data__value">{entity[entityName] || '-'}</span>
										<span className="rejected-data__value">{entity['rejected'] || '-'}</span>
									</span>
								)
								: (entity[entityName] || '-')
						}
					</span>
				</div>
			);
		});
		return res;
	}

	onHandleMouseOver(e) {
		this.highlightItems(e);
		this.setAxes(e);
	}

	onHandleMouseLeave(e) {
		this.hideHighlightItems(e);
	}

	setAxes(e) {
		const currentTarget = e.currentTarget;

		setTimeout(() => {
			const { axesXRef, axesYRef, wrapperRect } = this.props.axesCalculateData;
			const targetRect = currentTarget.querySelector('.data-item__highlight').getBoundingClientRect();

			const top = (targetRect.top - wrapperRect.top);
			const left = (targetRect.left - wrapperRect.left) + targetRect.width;

			axesXRef.style.top = `${top}px`;
			axesXRef.style.display = 'block';

			axesYRef.style.left = `${left}px`;
			axesYRef.style.display = 'block';
		}, 300);
	}

	highlightItems(e) {
		const $elements = this.getHighlightElements(e);

		forEach($elements, $el => {
			$el.style.transform = 'scaleY(1)';
		});
	}

	hideHighlightItems(e) {
		const $elements = this.getHighlightElements(e);

		forEach($elements, $el => {
			$el.style.transform = 'scaleY(0)';
		});
	}

	getHighlightElements(e) {
		const currentTarget = e.currentTarget;
		const rowId = currentTarget.getAttribute('data-row');
		const type = currentTarget.getAttribute('data-row-type');
		const selector = `js-item-by-row-index-${type}-${rowId}`;

		return document.getElementsByClassName(selector);
	}
}

Data.propTypes = propTypes;
export default Data;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/table/cells/data.js